import {
  Component, ViewEncapsulation, OnInit, Input, EventEmitter, Output
} from '@angular/core';
import { CommonService } from '../services/common.service';
import { StoreConfig } from '../interfaces/store-config.interface';
import { MenuItem } from '../interfaces/menu-item.interface';
import { MemberType } from '../enums/member-type.enum';
import { MemberLevel } from '../enums/member-level.enum';
import { MenuPortal } from '../enums/menu-portal.enum';
import { environment } from '../../../environments/environment';
import { CacheService } from '../services/cache.service';
import { CacheKey } from '../constants/cachekey.constants';
import { Member } from '../interfaces/member.interface';
import { RoutePath } from '../enums/route-path.enum';
import { AppMessageService } from '../../app-message.service';
import { Router } from '@angular/router';
import { SharedConstants } from '../constants/shared.constants';
import { ExternalLinkNames } from '../enums';
import { SecongLevelMenuConstants } from '../constants/second-level-menu.constants';
@Component({
  selector: 'app-menu',
  templateUrl: '../templates/template1/views/app-menu.component.html',
  styleUrls: ['../templates/template1/themes/default/less/app-menu.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class AppMenuComponent implements OnInit {
  reports: any;
  @Input()
  isCollapsed = false;
  @Input()
  isHamburger: boolean;
  @Output() forceOpen = new EventEmitter();
  appSites: MenuItem[];
  countryName: string;
  languageCode: string;
  store: StoreConfig;
  countryCode: string;
  storeId: number;
  level = 0;
  isCollapse: false;
  subMenuselected: Number = -1;
  routePath = RoutePath;
  // To Store the Stacking Push-Menus
  pushMenuStack = [];
  childMenus = [];
  parentMenuName: string;
  appMenus = [];
  showFPCMenu: boolean;

  constructor(
    private _commonService: CommonService,
    private _cacheService: CacheService,
    private _appMessageService: AppMessageService,
    private _router: Router
  ) {
  }

  ngOnInit() {
    this.store = this._cacheService.get(CacheKey.StoreConfiguration);
    if (this._cacheService.get(CacheKey.CountryMetaData)) {
      this._commonService.updateCountryCodeinCookie();
    }
    this.countryCode = this._cacheService.getCookieValue(CacheKey.countryCode);
    this.languageCode = this._cacheService.getCookieValue(CacheKey.languageCode);
    if (this.store) {
      this.storeId = this.store.id;
    }
    const userinfo = this._cacheService.get(CacheKey.UserInfo);
    if (userinfo) {
      const notWholesaleQualifiedFBO = userinfo.memberTypeId === MemberType.DISTRIBUTOR && (!userinfo.wholesaleQualified || userinfo.memberTitleId === MemberLevel.NOVUSCUSTOMER);
      this.showFPCMenu = userinfo.memberTypeId === MemberType.PREFERREDCUSTOMER || notWholesaleQualifiedFBO ; // show only reports menu in black bar
    }
    this.getMenus();
    this.getApplicationSites();
    if (this.isHamburger) {
      this._appMessageService.listenOpenPushMenuFn(this.openPushMenu.bind(this));
    }
  }

  getApplicationSites(): void {
    const userBasicInfo: Member = this._cacheService.get(CacheKey.UserInfo);
    let isoCountryCode: string = this._cacheService.getCookieValue(CacheKey.countryCode);
    // const countryId: number = Number(this._localStorageService.get('countryId'));
    const countryId: number = this._cacheService.getCookieValue(CacheKey.CountryId);
    const languageCode: string = this._cacheService.getCookieValue(CacheKey.languageCode);
    let portalID;
    let memberLevelId;
    isoCountryCode = (isoCountryCode && isoCountryCode.length === 2) ?
      this._commonService.getISOThreeLetterCountryCode(isoCountryCode).toLocaleUpperCase() :
      isoCountryCode.toLocaleUpperCase();
    if (userBasicInfo) {
      memberLevelId = (userBasicInfo.memberTypeId === MemberType.DISTRIBUTOR) ?
        MemberLevel.PREFERREDCUSTOMER : MemberLevel.RETAIL;
      portalID = MenuPortal.Account;
    } else {
      memberLevelId = MemberLevel.RETAIL;
      portalID = MenuPortal.Corporate;
    }
    if (this.storeId && countryId) {
      this._commonService.getApplicationSites(portalID, this.storeId, countryId, languageCode, memberLevelId)
        .subscribe((sites: MenuItem[]) => {
          if (sites) {
            this.appSites = sites;
            this.reports = this.appSites.filter(x => x.name === SharedConstants.REPORTING)[0] as any;
          }
        });
    }
  }
  /**
   * navigation to reports
   * @param subMenuUrl
   */
  navigateToReports(subMenuUrl: string) {
    window.location.href = environment.reportsURL + '/'
      + this.countryCode.toLowerCase() + '/' + this.languageCode.toLowerCase() + subMenuUrl;
  }

   /**
   * navigation to my order reports
   * @param subMenuUrl
   */
  navigateToOrderReports(subMenuUrl: string) {
    window.location.href = environment.reportsURL + subMenuUrl;
  }

  /**
* navigation to account portal
*/
  navigateToAccount(): void {
    if (this._cacheService.get(CacheKey.CountryMetaData)) {
      this._commonService.updateCountryCodeinCookie();
  }
    const languageCode: string = this._cacheService.getCookieValue(CacheKey.languageCode);
    window.location.href = environment.accountSiteURL +
      '/' + this.countryCode.toLowerCase() + '/' + languageCode.toLowerCase() + '/account/dashboard';
  }
  /**
   *Navigate to Id card Screen in Account Portal
   *
   * @memberof AppMenuComponent
   */
  navigateToToolsScreen(path: string): void {
    if (path) {
      if (this._cacheService.get(CacheKey.CountryMetaData)) {
        this._commonService.updateCountryCodeinCookie();
      }
      window.location.href = environment.accountSiteURL +
        '/' + this.countryCode.toLowerCase() + '/' + this.languageCode.toLowerCase() + '/account/' + path;
     }
  }
  /**
     * To get Second level Menus
     * @memberof AppMenuComponent
     */
  getMenus(): void {
    this._commonService.getApplicationMenus().subscribe((res: any) => {
      this.appMenus = res.filter(menuitem => menuitem.mobile);
      if(this.appMenus && this.showFPCMenu){
        this.getFPCMemberMenu();
      }
    });
  }

  /**
   * To display current menuitems when
   * back button clicked from Submenu
   * @memberof AppMenuComponent
   */
  goBack(): void {
    this.pushMenuStack.pop();
    if (this.pushMenuStack && this.pushMenuStack.length > 0) {
      const menu = this.pushMenuStack[this.pushMenuStack.length - 1];
      if (menu) {
        this.level = menu.level;
        this.childMenus = menu.childs;
        this.parentMenuName = menu.name;
      }
    } else {
      this.level = 0;
      this.childMenus = [];
      this.parentMenuName = '';
    }
  }

  /**
   * To display current menuitems when
   * right arrow clicked from any Parent menu
   * @param {*} menu
   * @param {number} level
   * @memberof AppMenuComponent
   */
  openPushMenu(menu: any, level: number): void {
    this.level = level + 1;
    this.childMenus = menu.childs;
    this.parentMenuName = menu.name;
    const menuDetail = {
      level: this.level,
      childs: this.childMenus,
      name: this.parentMenuName
    };
    this.pushMenuStack.push(menuDetail);
  }

  /**
   * To display current menuitems when
   * right arrow clicked from any Child menu item
   * @param {*} menuDetail
   * @memberof AppMenuComponent
   */
  openChildPushMenu(menuDetail: any): void {
    if (menuDetail) {
      this.openPushMenu(menuDetail, menuDetail.level);
    }
  }

  /**
     * @description Internal Link which is not having a CMS content
     * @param  {any} menuItem
     * @returns void
     */
  menuItemClicked(menuItem: MenuItem): void {
    if (menuItem && menuItem.childs && menuItem.childs.length > 0) {
      this.openPushMenu(menuItem, 0);
    } else {
      // Navigate to external links start
      if (menuItem.externalLink) {
        const target = menuItem.openInNewTab ? '_blank' : '_self';
        if (menuItem.name === SecongLevelMenuConstants.TRAINING) {
          this.openTrainingSession();
        }
        if (menuItem.name === SecongLevelMenuConstants.TOOLS) {
          this.navigateToTools(RoutePath.TOOLS);
        }
        if (menuItem.name === SecongLevelMenuConstants.RECOGNITION) {
          this.openRecognitionLink();
        }
        if (menuItem.name === SecongLevelMenuConstants.FLP360) {
          this.navigateToFLP360();
        }
        this._appMessageService.setCollapseMenu(false);
        return;
      }
      // Navigate to external links end
      let parentUrl = menuItem.parentURL;
      const origin = environment.production ? window.location.origin : environment.corporateUrl;
      if (menuItem.static) {
        parentUrl = this._commonService.getParentUrl(menuItem.parentPortal);
      }
      if (parentUrl && menuItem.url && (origin === parentUrl)) {
        const navigateURL = '/' + this.countryCode.toLowerCase() + '/' + this.languageCode.toLowerCase() + menuItem.url;
        this._router.navigateByUrl(navigateURL);
        this.pushMenuStack = [];
        this._appMessageService.setCollapseMenu(false);
        // this._commonService.scrollByValue(0,0,0);
      } else if (parentUrl && menuItem.url) {
        const redirectURL = parentUrl + '/' + this.countryCode.toLowerCase() + '/' + this.languageCode.toLowerCase() + menuItem.url;
        window.location.href = decodeURIComponent(encodeURIComponent(redirectURL));
        this._appMessageService.setCollapseMenu(false);
      }
    }
  }

  /**
   * Open Pushmenu while parent menu clicked from
   * Secondlevel menu(outside of hamburger menu)
   * @param {string} menuName
   * @memberof AppMenuComponent
   */
  openAppMenu(menuName: string): void {
    const menu = this.appMenus.filter((menuItem) => menuItem.name === menuName);
    if (menu && menu[0]) {
      this.forceOpen.emit(true);
      const menuFn = this._appMessageService.getOpenPushMenuFn();
      menuFn(menu[0], 0);
    }
  }
  showSubMenu() {
    $('#business-menu-list').css('display', 'block');
    const subMenu = <HTMLElement>document.getElementsByClassName('subMenu')[0];
    subMenu.focus();
  }

  showSubsubMenu(index: any) {
    this.subMenuselected = index;
  }

  hideMybusiness() {
    document.getElementById('business-menu-list').style.display = 'none';
  }

  // navigateToFAQ(route: string): void {
  //   if (route) {
  //       window.location.href = environment.accountSiteURL + '/' + this.countryCode.toLowerCase()
  //       + '/' + this.languageCode.toLowerCase() + '/' + RoutePath.FBOFAQ;
  //   }
  // }

  /**
   *  Open Trainings page
   * @memberof AppMenuComponent
   */
  openTrainingSession(): void {
    let training = this.appMenus.find(x => x.name === SecongLevelMenuConstants.TRAINING);
    if (training) {
      let navigatingCountry = training.countrySpecificNavigation.find(x => x.countryCode && (x.countryCode.toUpperCase() === this.countryCode.toUpperCase()));
      if (!navigatingCountry) {
        navigatingCountry = training.countrySpecificNavigation.find(x => x.countryCode.toUpperCase() === 'USA')
      }
      if (navigatingCountry.navgatingUrl) {
        window.open(navigatingCountry.navgatingUrl, '_blank');
      }
    }
  }


  /**
   * @description navigate to the tools landing page
   * @date 2019-04-12
   * @param {string} route
   * @memberof AppMenuComponent
   */
  navigateToTools(route: string): void {
    let tools = this.appMenus.find(x => x.name === SecongLevelMenuConstants.TOOLS);
    if (tools) {
      let navigatingCountry = tools.countrySpecificNavigation.find(x => x.countryCode && (x.countryCode.toUpperCase() === this.countryCode.toUpperCase()));
      if (navigatingCountry && navigatingCountry.navgatingUrl) {
        window.open(navigatingCountry.navgatingUrl, '_blank');
      }else{
        window.location.href = environment.accountSiteURL + '/' + this.countryCode.toLowerCase() +
        '/' + this.languageCode.toLowerCase() + '/' + route;

      }
    }
  }

  /**
   * @description open Recognition link
   * @date 2019-04-16
   * @memberof AppMenuComponent
   */
  openRecognitionLink(): void {
    const recognitionMenu = this.appMenus.find(x => x.name === SecongLevelMenuConstants.RECOGNITION);
    if (recognitionMenu) {
      const navigatingCountry = recognitionMenu.countrySpecificNavigation.
                            find(x => x.countryCode && (x.countryCode.toUpperCase() === this.countryCode.toUpperCase()));
      if (navigatingCountry.navgatingUrl) {
        window.open(navigatingCountry.navgatingUrl, '_blank');
      } else if (environment.enableRecognitionPage) {
        window.location.href = environment.accountSiteURL + '/' + this.countryCode.toLowerCase() +
        '/' + this.languageCode.toLowerCase() + '/' + RoutePath.RECOGNITION;
      } else {
        window.open(environment.recognitionMenuRedirectUrl, '_blank');
      }
    }
  }

  /**
  * navigate to flp360
  */
  navigateToFLP360(): void {
    setTimeout(() => {
      this._appMessageService.setFlp360LoginSubject(true);
    }, 0);
  }

 
  /**
   * get Black navigation menus for FPC members based on MemberType
   */
  getFPCMemberMenu(): void {
    const showMenus = this.appMenus.filter(menu => menu.enabledMemberTypes.find(x => x === MemberType.PREFERREDCUSTOMER));
    if (showMenus.length > 0) {
      for (let i = 0; i < showMenus.length; i++) {
        if (showMenus[i].name === SecongLevelMenuConstants.REPORTS) {
          showMenus[i].url = SecongLevelMenuConstants.REPORTS_URL;
        }
      }
      this.appMenus = showMenus;
    } else {
      this.appMenus = [];
    }
  }
}

